import axios from 'axios';
import { PasswordSetResult, PASSWORD_DETAIL_ERROR_MAP } from '../@types/passwordSetResult';

/**
 * Inspects an error thrown by a password API call and returns the appropriate
 * PasswordSetResult. The mapping from TMS `detail` strings to result values is
 * maintained in `PASSWORD_DETAIL_ERROR_MAP` – add new entries there to handle
 * additional TMS-specific error messages without touching this function.
 *
 * Error body shape coming from the call chain:
 *   TMS API (400) → tms-middleware withErrorHandling wraps as { remoteError: { status, title, detail } }
 *   → alm-auth-proxy proxyRequest forwards it unchanged
 *   → alm-web axios throws with err.response.data = { remoteError: { ... } }
 *
 * We therefore check `data.remoteError.detail` first, with a fallback to
 * `data.detail` for any future direct error responses.
 */
export function classifyPasswordError(err: unknown): PasswordSetResult {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as any;
    const detail: unknown = data?.remoteError?.detail ?? data?.detail;
    if (typeof detail === 'string' && detail in PASSWORD_DETAIL_ERROR_MAP) {
      return PASSWORD_DETAIL_ERROR_MAP[detail];
    }
  }
  return PasswordSetResult.Failed;
}
